<template>
	<main :id="mainContentId" :tabindex="-1">
		<slot />
	</main>
</template>
